/** Query flag that makes each catalog open its own history entry. */
export const STARTUP_PROFILE_VIEW_PARAM = 'v';

export function withStartupProfileParams(
  current: URLSearchParams,
  startupId: string,
  viewToken: string
): URLSearchParams {
  const next = new URLSearchParams(current);
  next.delete('reset');
  next.set('startupId', startupId);
  next.set(STARTUP_PROFILE_VIEW_PARAM, viewToken);
  return next;
}

export function withoutStartupProfileParams(current: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(current);
  next.delete('startupId');
  next.delete(STARTUP_PROFILE_VIEW_PARAM);
  next.delete('reset');
  return next;
}

/**
 * A back navigation can land after the investor has already opened a startup.
 * That pop removes the new startup id and the profile snaps shut. Put it back
 * only for that in-flight case.
 */
export function shouldRestoreStartupAfterPop(input: {
  startupIdParam: string | null;
  selectedStartupId: string | null;
  recoverStartupId: string | null;
}): boolean {
  return (
    !input.startupIdParam &&
    !!input.recoverStartupId &&
    !!input.selectedStartupId &&
    input.selectedStartupId === input.recoverStartupId
  );
}
